import { Box } from '@factorialco/deprecated-design-system'
import {
  BankingAccountDetailedFragment,
  BankingBankAccountFragment,
  LegalEntityForSelectFragment,
} from 'generated/resources/graphql'

import { AccountCard } from 'modules/banking/components/AccountCard'

interface AccountCardsProps {
  accounts: BankingAccountDetailedFragment[]
  search: string
  onCardClick: (
    account: BankingAccountDetailedFragment,
    bankAccount: BankingBankAccountFragment
  ) => void
  selectedLegalEntity?: LegalEntityForSelectFragment
}
export const AccountCardList = ({
  accounts,
  search,
  selectedLegalEntity,
  onCardClick,
}: AccountCardsProps) => {
  const bankAccountMatchesSearch = (bankAccount: BankingBankAccountFragment) => {
    const searchText = search.toUpperCase()
    const accountNumber = bankAccount.accountNumber
    const visibleAccountNumber = accountNumber.substring(accountNumber.length - 4)
    return (
      bankAccount.accountAlias?.toUpperCase().includes(searchText) ||
      bankAccount.accountBalanceCents.toString().toUpperCase().includes(searchText) ||
      visibleAccountNumber.toUpperCase().includes(searchText)
    )
  }

  const filteredAccounts = accounts
    .filter((account) => {
      const matchesLegalEntity = !selectedLegalEntity
        ? true
        : account.legalEntity.id == selectedLegalEntity.id
      return matchesLegalEntity && account.onboarding.status === 'completed'
    })
    .sort((a, b) => a.id - b.id)

  return (
    <>
      {filteredAccounts
        .map((account) => {
          return account.bankAccounts
            .filter((bankAccount) => bankAccountMatchesSearch(bankAccount))
            .sort((a, b) => a.id - b.id)
            .map((bankAccount) => {
              return bankAccount && bankAccount.id ? (
                <Box key={'account_' + account.id + '_bankaccount_' + bankAccount.id}>
                  <AccountCard
                    account={account}
                    bankAccount={bankAccount}
                    onCardClick={(selectedAccount) => onCardClick(account, selectedAccount)}
                  />
                </Box>
              ) : (
                <></>
              )
            })
        })
        .flat()}
    </>
  )
}
